// src/config/navigation.jsx
import {
  BarChart3,
  Target,
  Building2,
  Calculator,
  DollarSign,
  ClipboardList,
  Hammer,
  Calendar,
  Camera,
  Shield,
  Activity,
  Briefcase,
  FileText,
  Users,
  Kanban,
  LayoutDashboard,
  Tag,
  Receipt,
  List,
  Wrench,
  Search,
} from 'lucide-react';

// Static constant — no function call needed, reference is stable across renders
export const NAV_ITEMS = [
  { id: 'dashboard', path: '/', label: 'The Hub', icon: BarChart3 },
  { id: 'properties', path: '/properties', label: 'Properties', icon: Building2 },

  // ─── Acquisition Phase ────────────────────────────────────────────────────
  {
    id: 'acquisition',
    label: 'Acquisition',
    icon: Target,
    children: [
      { id: 'acq-dashboard', path: '/acquisition', label: 'Dashboard', icon: LayoutDashboard },
      { id: 'acq-all', path: '/acquisition/all', label: 'All Leads', icon: List },
      { id: 'find-leads', path: '/find-leads', label: 'Find Leads', icon: Search },
      { id: 'acq-pipeline', path: '/leads', label: 'Flip Flow', icon: Kanban },
      { id: 'comps', path: '/comps', label: 'Comps', icon: Building2 },
    ],
  },

  // ─── Rehab Phase ──────────────────────────────────────────────────────────
  {
    id: 'rehab',
    label: 'Rehab',
    icon: Hammer,
    children: [
      { id: 'rehab-dashboard', path: '/rehab', label: 'Dashboard', icon: LayoutDashboard },
      { id: 'rehab-all', path: '/rehab/all', label: 'All Projects', icon: List },
      { id: 'rehab-pipeline', path: '/rehab-pipeline', label: 'Flip Flow', icon: Kanban },
      { id: 'photos', path: '/photos', label: 'Photo Log', icon: Camera },
    ],
  },

  // ─── Selling Phase ────────────────────────────────────────────────────────
  {
    id: 'selling',
    label: 'Selling',
    icon: Tag,
    children: [
      { id: 'selling-dashboard', path: '/selling', label: 'Dashboard', icon: LayoutDashboard },
      { id: 'selling-all', path: '/selling/all', label: 'All Projects', icon: List },
      { id: 'selling-pipeline', path: '/selling-pipeline', label: 'Flip Flow', icon: Kanban },
      { id: 'listing-mgmt', path: '/selling/listings', label: 'Listings & Offers', icon: FileText },
    ],
  },

  // ─── Tools ──────────────────────────────────────────────────────────────
  {
    id: 'tools',
    label: 'Tools',
    icon: Wrench,
    children: [
      { id: 'flip-analyzer', path: '/flip-analyzer', label: 'Flip Analyzer', icon: Calculator },
      { id: 'brrrr-analyzer', path: '/brrrr-analyzer', label: 'BRRRR Analyzer', icon: Calculator },
      {
        id: 'loan-calculator',
        path: '/loan-calculator',
        label: 'Loan Calculator',
        icon: DollarSign,
      },
      {
        id: 'rehab-estimator-tool',
        path: '/rehab-estimator',
        label: 'Rehab Estimator',
        icon: ClipboardList,
      },
    ],
  },

  // ─── Standalone Items ─────────────────────────────────────────────────────
  { id: 'expenses', path: '/expenses', label: 'Expenses', icon: Receipt },
  { id: 'scheduler', path: '/scheduler', label: 'Scheduler', icon: Calendar },
  { id: 'approvals', path: '/approvals', label: 'Approvals', icon: Shield, badge: true },
  { id: 'analysis', path: '/analysis', label: 'Live Analysis', icon: Activity },
  { id: 'portfolio', path: '/portfolio', label: 'Portfolio', icon: Briefcase },
  { id: 'reports', path: '/reports', label: 'Reports', icon: FileText },
  { id: 'team', path: '/team', label: 'Team', icon: Users },
];

// Legacy function export for backward compatibility with any direct callers
export const getNavItems = () => NAV_ITEMS;
